import axiosInstance from '../axiosConfigCMS';

export default {
  async getContent() {
    const response = await axiosInstance.get('/product-page');
    return response.data;
  },
  async getSKU(sku) {
    // SKU is string
    const response = await axiosInstance.get(`/products?SKU=${sku}`);
    return response.data;
  },
  async getFeatured() {
    const response = await axiosInstance.get(`/products?isFeatured=true`);
    return response.data;
  },
  async getAllProducts() {
    const response = await axiosInstance.get(`/products`);
    return response.data;
  },
};
